import styled from '@emotion/styled';

export const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;

  &.common-radio-item {
    /* min-height: 40px; */
    padding: 4px 12px 4px 8px;
  }

  &.common-checkbox-item {
    /* min-inline-size: 54px; */
    padding: 9px 12px 9px 8px;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[100]};
  }
`;

export const InputWrapper = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
`;

export const LabelText = styled.p`
  display: -webkit-box;
  font-size: 14px;
  line-height: 18px;
  padding-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
